<template>
  <div>
    <v-card>
      <v-app-bar flat>
        <v-toolbar-title class="font-weight-medium">Categorias Externas</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="getCategories" :loading="loading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="filter"
          append-icon="mdi-magnify"
          label="Pesquisar categorias"
          style="max-width: 350px"
          single-line
          hide-details
          clearable
          @click:append="getCategories"
          @keydown.enter="getCategories"
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="categories"
        :disabled="loading"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loading-text="A carregar..."
        fixed-header
        max-height="500px"
      >
        
        <template v-slot:item.local_category="{ item }">
          <ScopeProvider scope="products.categories.edit_local_category">
            <local-category-select
              :category="item.local_category"
              @change="setLocalCategory(item, $event)"
              creatable
            />
            <template v-slot:not>
              {{ item.local_category.name }}
            </template>
          </ScopeProvider>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {
  index as indexCategories,
  changeLocalCategory
} from "../services/categories";

import LocalCategorySelect from '../components/autocompletes/LocalCategorySelect';
import ScopeProvider from '../components/ScopeProvider';

export default {
  name: "categories",
  components: {
    LocalCategorySelect,
    ScopeProvider
  },
  data: () => ({
    loading: false,
    filter: "",
    categories: [],
    options: {},
    totalItems: 0,
    headers: [
      {
        text: "Nome",
        value: "name",
      },
      {
        text: "Tipo de Produto",
        value: "local_category"
      }
    ],
  }),
  methods: {
    async setLocalCategory(category, local_category) {
      category.local_category = local_category;
      try {
        const response = await changeLocalCategory(category.id, local_category);
        category = response;
      } catch (e) {
        category.local_category = null;
      }
    },
    async getCategories() {
      this.loading = true;
      try {
        const response = await indexCategories({
          filter: this.filter,
          ...this.options
        });

        this.categories = response.data.map((category) => ({
          ...category,
          local_category: {
            id: category.local_category_id,
            name: category.local_category,
          },
        }));

        this.totalItems = response.total;
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: "Falha ao carregar categorias externas",
          color: "red",
        });
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.getCategories();
      },
      deep: true,
    },
    filter: function (value) {
      if (value == null) this.getCategories();
    },
  },
};
</script>